import { useStartDialogStore } from "@features/session/hooks/useShowStartDialog";
import { router } from "expo-router";
import { Appbar, Button } from "react-native-paper";

const Sandbox = () => {
	const resetStartDialogShown = useStartDialogStore(
		(store) => store.resetStartDialogShown,
	);

	return (
		<>
			<Appbar.Header>
				<Appbar.BackAction onPress={() => router.back()} />
				<Appbar.Content title="Sandbox Updated" />
			</Appbar.Header>
			<Button onPress={resetStartDialogShown}>Reset Start Dialog</Button>
		</>
	);
};

export default Sandbox;
